import ReactEChartsCore from 'echarts-for-react/lib/core';
import { echarts, COLOR_PALETTE } from '../../shared/echarts-config';
import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import type { FpServiceSlice } from '../../../../types/analytics.types';

type ReferralsByServiceDonutProps = {
  categories: FpServiceSlice[];
};

const TITLE = 'Client Referrals by Service Type';
const SUBTITLE = 'Where partner clients are being routed';

const buildOptions = (categories: FpServiceSlice[]) => ({
  tooltip: {
    trigger: 'item' as const,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderColor: '#e5e7eb',
    borderWidth: 1,
    textStyle: { color: '#374151', fontSize: 13 },
    formatter: '{b}: {c} ({d}%)',
  },
  legend: {
    orient: 'vertical' as const,
    right: '2%',
    top: 'middle',
    icon: 'circle',
    textStyle: { color: '#374151', fontSize: 13 },
    formatter: (name: string) => {
      const slice = categories.find((c) => c.categoryName === name);
      return slice ? `${name}  ${slice.count}  ${slice.percentage}%` : name;
    },
  },
  series: [
    {
      name: TITLE,
      type: 'pie' as const,
      radius: ['45%', '70%'],
      center: ['32%', '50%'],
      avoidLabelOverlap: true,
      label: { show: false },
      labelLine: { show: false },
      data: categories.map((c, i) => ({
        name: c.categoryName,
        value: c.count,
        itemStyle: { color: COLOR_PALETTE[i % COLOR_PALETTE.length] },
      })),
    },
  ],
});

export const ReferralsByServiceDonut = ({ categories }: ReferralsByServiceDonutProps) => {
  if (categories.length === 0 || categories.every((c) => c.count === 0)) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState message="No referral data for the selected filters." />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <ReactEChartsCore
        echarts={echarts}
        option={buildOptions(categories)}
        style={{ height: 300 }}
        notMerge
        lazyUpdate
      />
    </ChartContainer>
  );
};
